export default "__VITE_ASSET__CxoZgpJ9__"